import React from 'react';

import styles from './styles.module.scss';

interface INotFoundPageProps {
  title?: string;
  description?: string;
}

const NotFoundPage = ({
  title = 'Something went wrong',
  description = 'Please refresh the page or try again in a few minutes.',
}: INotFoundPageProps) => (
  <div className={styles.wrapper}>
    <svg
      className={styles.icon}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="40"
        cy="40"
        r="38"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <rect
        x="37.5"
        y="22"
        width="5"
        height="26"
        rx="2.5"
        fill="currentColor"
      />
      <circle
        cx="40"
        cy="56"
        r="3"
        fill="currentColor"
      />
    </svg>
    <div className={styles.title}>{title}</div>
    <div className={styles.description}>{description}</div>
  </div>
);

export default NotFoundPage;
